import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const MiniImage = ({ src, alt, placeholder }) => {
  const [loading, setLoading] = useState(true);
  const [currentSrc, setCurrentSrc] = useState(placeholder || src);

  const preloadImage = () => {
    const image = new Image();
    image.src = src;
    image.onload = () => {
      setLoading(false);
      setCurrentSrc(src);
    };
  };

  useEffect(() => {
    if (!placeholder) {
      setLoading(false);
      return;
    }

    preloadImage();
  }, [src]);

  const style = {
    opacity: loading ? 0.5 : 1,
    transition: 'opacity .15s linear',
  };

  if (loading) {
    style.height = '100%';
  }

  return (
    <>
      <img
        src={currentSrc}
        alt={alt}
        style={style}
      />
    </>
  );
};

MiniImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};

export default MiniImage;
